import React from "react";
import { Check, FileImage, QrCode, Wifi } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

const stepIcons = [QrCode, Wifi, FileImage, Check];

export default function SetupStepsSection() {
  const { t } = useLanguage();
  const copy = t("kylendar.setup");

  return (
    <section id="setup" className="home-wash relative bg-gradient-to-b from-white via-[#eafbf2] to-white py-20 sm:py-24">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
        <div className="home-section-mark mx-auto max-w-2xl text-center">
          <p className="home-eyebrow">{copy.eyebrow}</p>
          <h2 className="home-title mt-3">{copy.title}</h2>
        </div>

        <ol className="relative mx-auto mt-14 grid max-w-5xl gap-8 rounded-[2rem] border border-brand-100 bg-gradient-to-br from-[#f7fffb] via-[#eafbf2] to-white p-6 shadow-[0_24px_52px_-38px_rgba(8,122,88,.35)] sm:grid-cols-4 sm:gap-4 sm:p-8">
          <span
            className="pointer-events-none absolute left-[12%] right-[12%] top-[3.25rem] hidden border-t border-dashed border-brand-200 sm:block"
            aria-hidden="true"
          />
          {stepIcons.map((Icon, index) => {
            const [title, body] = copy.steps[index];
            return (
            <li key={title} className="group relative text-center">
              <div className="home-icon-well relative z-10 rounded-full ring-4 ring-white/90">
                <span className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-gradient-to-br from-brand to-emerald-400 text-[10px] font-bold text-slate-950">
                  {index + 1}
                </span>
                <Icon className="h-5 w-5" aria-hidden="true" />
              </div>
              <h3 className="mt-4 font-display text-sm font-bold text-slate-950">{title}</h3>
              <p className="mx-auto mt-1.5 max-w-[160px] text-xs leading-5 text-slate-500">{body}</p>
            </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
